/**
 * Cliente de API para el módulo de Clientes, crédito y facturación.
 */

import { apiRequest } from "./api";

export interface CustomerPublic {
  id: string;
  name: string;
  phone: string | null;
  email: string | null;
  tax_id: string | null;
  legal_name: string | null;
  tax_regime: string | null;
  zip_code: string | null;
  credit_limit_cents: number;
  credit_balance_cents: number;
  credit_days: number;
  notes: string | null;
  is_active: boolean;
  created_at: string;
}

export interface CustomerSaleHistoryItem {
  id: string;
  series: string;
  folio: number;
  total_cents: number;
  status: string;
  created_at: string;
}

export interface CustomerWorkOrderHistoryItem {
  id: string;
  series: string;
  folio: number;
  device_type: string;
  brand: string | null;
  model: string | null;
  status: string;
  received_at: string;
}

export interface CustomerDetailPublic {
  customer: CustomerPublic;
  sales: CustomerSaleHistoryItem[];
  orders: CustomerWorkOrderHistoryItem[];
}

export interface CustomerCreate {
  name: string;
  phone?: string | null;
  email?: string | null;
  tax_id?: string | null;
  legal_name?: string | null;
  tax_regime?: string | null;
  zip_code?: string | null;
  credit_limit_cents?: number;
  credit_days?: number;
  notes?: string | null;
}

export interface CustomerUpdate {
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  tax_id?: string | null;
  legal_name?: string | null;
  tax_regime?: string | null;
  zip_code?: string | null;
  credit_limit_cents?: number | null;
  credit_days?: number | null;
  notes?: string | null;
  is_active?: boolean | null;
}

const BASE = "/api/v1/customers";

export function listCustomers(params?: {
  q?: string;
  is_active?: boolean;
  limit?: number;
  offset?: number;
}): Promise<{ items: CustomerPublic[]; total: number }> {
  const query = new URLSearchParams();
  if (params?.q) query.set("q", params.q);
  if (params?.is_active !== undefined) query.set("is_active", String(params.is_active));
  if (params?.limit) query.set("limit", String(params.limit));
  if (params?.offset) query.set("offset", String(params.offset));
  const qs = query.toString();
  return apiRequest(`${BASE}${qs ? `?${qs}` : ""}`);
}

export function getCustomer(id: string): Promise<CustomerPublic> {
  return apiRequest(`${BASE}/${id}`);
}

export function getCustomerDetail(id: string): Promise<CustomerDetailPublic> {
  return apiRequest(`${BASE}/${id}/detail`);
}

export function createCustomer(payload: CustomerCreate): Promise<CustomerPublic> {
  return apiRequest(BASE, { method: "POST", body: payload });
}

export function updateCustomer(id: string, payload: CustomerUpdate): Promise<CustomerPublic> {
  return apiRequest(`${BASE}/${id}`, { method: "PATCH", body: payload });
}

